export default __webpack_public_path__ + "static/avatar-tag-anatomy-dark-6d01f9791822ed7e1461c8c48f7b91676c90af6d624750f07e2ed15d8fb629a5.png";